import styled, { css } from 'styled-components'

import type { ButtonProps } from '@components/ui/Buttons'
import { BUTTON_CSS_VARIABLES, IconButton } from '@components/ui/Buttons'
import { XmarkRegularIcon } from '@components/ui/svgIcons'

const StyledIconButton = styled(IconButton)<{ $absolutePositioned?: boolean }>`
  border-radius: 50%;
  padding: 4px;
  ${BUTTON_CSS_VARIABLES.backgroundColor}: ${({ theme }) => theme.colors.gray[105]};
  ${BUTTON_CSS_VARIABLES.borderColor}: ${({ theme }) => theme.colors.gray[105]};
  ${BUTTON_CSS_VARIABLES.color}: ${({ theme }) => theme.colors.gray[0]};
  ${BUTTON_CSS_VARIABLES.hoverBackgroundColor}: ${({ theme }) => theme.colors.common.inputBorder};
  ${BUTTON_CSS_VARIABLES.hoverBorderColor}: ${({ theme }) => theme.colors.common.inputBorder};

  &::before {
    border-radius: 50%;
  }

  ${({ $absolutePositioned }) =>
    $absolutePositioned &&
    css`
      position: absolute;
      top: 5px;
      right: 5px;
    `}
`

interface DialogCloseButtonProps extends Omit<ButtonProps, 'children'> {
  absolutePositioned?: boolean
}

export function DialogCloseButton({ absolutePositioned = false, ...rest }: DialogCloseButtonProps) {
  return (
    <StyledIconButton $absolutePositioned={absolutePositioned} size="small" variant="secondaryText" {...rest}>
      <XmarkRegularIcon size={12} />
    </StyledIconButton>
  )
}
